import {NetxThemeMode} from '../constants';

export const getBrowserPreferedThemeMode = () => {
	return window.matchMedia?.('(prefers-color-scheme: dark)').matches
		? NetxThemeMode.DARK
		: NetxThemeMode.LIGHT;
};
